import React from 'react';
import './../styles/table.css';

const RepoTable = ({ repos }) => {
  if (!repos || repos.length === 0) {
    return null;
  }

  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Full Name</th>
            <th>Stars</th>
            <th>Forks</th>
            <th>Language</th>
            <th>Created At</th>
            <th>Visit</th>
          </tr>
        </thead>
        <tbody>
          {repos.map((repo) => (
            <tr key={repo.id}>
              <td>{repo.name}</td>
              <td>{repo.full_name}</td>
              <td>{repo.stargazers_count}</td>
              <td>{repo.forks_count}</td>
              <td>{repo.language}</td>
              <td>{new Date(repo.created_at).toLocaleDateString()}</td>
              <td>
                <a href={repo.html_url} target="_blank" rel="noopener noreferrer">
                  🔗
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RepoTable;
